// SPEC-43 · wakes the admin's callables as the admin opens. A
// callable nobody has called for a while has no server running: the first
// call waits about three seconds for one to start (measured on staging,
// 2026-10-31). So the page, before its chunk, its session and its gate are
// there, sends each one an AdminWarmUpRequest, which the server answers
// with nothing: no claim needed, nothing read, nothing logged. The base's
// call then finds a server up, and so does the first profile opened from it.
//
// Sent once per page load, with no session token: a plain POST in the
// shape the callables read. A warm-up that fails costs nothing; the real
// call starts the server as it did before.

import { FUNCTIONS_REGION } from "../data/transport";
import type { AdminWarmUpRequest } from "../schema/types";

/** The admin's callables: the base, its export, one athlete's profile, her bilans, her language (SPEC-44), a new account (SPEC-54). */
export const ADMIN_CALLABLES = ["adminUsers", "adminExport", "adminAccount", "adminBilan", "adminLanguage", "adminCreateAccount"] as const;

const WARM_UP: AdminWarmUpRequest = { warm: true };

type Send = (url: string, init: RequestInit) => Promise<unknown>;

/** Sends the warm-up to each admin callable; nothing without a project or a network. */
export function warmUpAdmin(projectId: string = import.meta.env.VITE_FIREBASE_PROJECT_ID, send: Send = fetch): void {
  if (!projectId || !navigator.onLine) return;
  for (const name of ADMIN_CALLABLES) {
    send(`https://${FUNCTIONS_REGION}-${projectId}.cloudfunctions.net/${name}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ data: WARM_UP }),
      credentials: "omit",
    }).catch((error: unknown) => {
      console.warn("[admin] warm-up not sent", { name, kind: error instanceof Error ? error.name : typeof error });
    });
  }
}
